import { IUserAccountStore } from '../../index'
import { INotificationErrorSended } from '../../../../actions/notification/errorSended'

export default function(
  store: IUserAccountStore,
  action: INotificationErrorSended,
): IUserAccountStore {
  return {
    ...store,
    notifications: {
      ...store.notifications,
      items: store.notifications.items.map(not =>
        String(not.id) === String(action.id) ? { ...not, sending: 2 } : not,
      ),
    },
  }
}
